// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-header-container{align-items:center;display:flex;height:60px;justify-content:space-between;width:100%}.layout-header-container img.logo{max-height:35px}@media print{.layout-header-container{display:none}}\n", ""]);
// Exports
module.exports = exports;
